import css from '../components/root-layout/root-layout.css';

import {useWindowWidth} from 'src/components/lib/responsive';


const breakpoint = parseInt(css['mobileScreenBreakpoint']);

export function useIsMobile(): boolean {
  return useWindowWidth() <= breakpoint;
}
